import React, { useState, useEffect } from 'react';
import './SilentModeDetector.css';

const SilentModeDetector = ({ gameStarted, onAudioFailure }) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  // Listen for audio failures from other components
  useEffect(() => {
    if (!gameStarted || !onAudioFailure) return;

    // Register this component to receive audio failure notifications
    onAudioFailure.current = () => {
      // Check if user has disabled this for the session
      if (sessionStorage.getItem('silentModePromptDisabled') === 'true') {
        return;
      }

      // Only show on mobile devices
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        setShowPrompt(true);
      }
    };

    return () => {
      if (onAudioFailure.current) {
        onAudioFailure.current = null;
      }
    };
  }, [gameStarted, onAudioFailure]);

  const handleClose = () => {
    if (dontShowAgain) {
      // Suppress for the session only (clears on page reload or user change)
      sessionStorage.setItem('silentModePromptDisabled', 'true');
    }
    setShowPrompt(false);
    setDontShowAgain(false); // Reset the toggle for next time
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div className="silent-mode-floating">
      <div className="silent-mode-header">
        <span className="silent-mode-icon">🔇</span>
        <span className="silent-mode-title">Your phone might be silenced! 🙉</span>
      </div>
      <div className="silent-mode-content">
        <p>Try turning off silent mode for more satisfying gameplay! 🔥💯</p>
        <div className="silent-mode-footer">
          <label className="dont-show-toggle">
            <input 
              type="checkbox" 
              checked={dontShowAgain} 
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
            <span className="toggle-text">Don't show again</span>
          </label>
          <button className="close-btn-primary" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SilentModeDetector;
